import { Zap, Home, Map } from "lucide-react";
import clsx from "clsx";
import type { ActiveTool } from "../../App";
// import { readMeta } from "../../lib/tenant-branding";

interface Props {
  activeTool: ActiveTool;
  onToolChange: (tool: ActiveTool) => void;
}

// const TOOL_DESCRIPTION: Record<ActiveTool, string> = {
//   "foerder-rechner": "Ihre Fördermittel berechnen – in unter 2 Minuten",
//   "dach-mapper": "Dachfläche vermessen & Solarertrag abschätzen",
//   "roi-simulator": "PV-Anlage planen & Rendite berechnen",
// };

export default function NEKOHeader({ activeTool, onToolChange }: Props) {
  // const p = new URLSearchParams(window.location.search);
  // const isWidget = p.has("tool") || p.get("embed") === "true";
  // const logoUrl = readMeta("x-tenant-logo-url");
  // const tenantName = readMeta("x-tenant-name");
  // const isPartnerEmbed = Boolean(logoUrl);

  return (
    <header className="bg-neko-dark-2 border-b border-neko-dark-3">
      <div className="max-w-2xl mx-auto px-4 py-4">
        {/* Logo + NEKO-Schriftzug — ausgeblendet für Embed
        {isWidget ? (
          <div className="flex items-center gap-3 mb-4">
            {isPartnerEmbed ? (
              <img
                src={logoUrl}
                alt={tenantName}
                loading="lazy"
                className="h-10 max-h-10 w-auto object-contain"
              />
            ) : (
              <>
                <div className="w-10 h-10 bg-neko-orange rounded-lg flex items-center justify-center flex-shrink-0">
                  <Zap className="w-6 h-6 text-neko-dark" strokeWidth={2.5} />
                </div>
                <div>
                  <span className="text-neko-white font-bold text-xl">NEKO</span>
                  <span className="text-neko-gray text-sm ml-2">{TOOL_DESCRIPTION[activeTool]}</span>
                </div>
              </>
            )}
          </div>
        ) : (
          <a href="/" className="flex items-center gap-3 mb-4 group cursor-pointer">
            <div className="w-10 h-10 bg-neko-orange rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-neko-orange/90 transition-colors">
              <Zap className="w-6 h-6 text-neko-dark" strokeWidth={2.5} />
            </div>
            <div>
              <span className="text-neko-white font-bold text-xl">NEKO</span>
              <span className="text-neko-gray text-sm ml-2">Bad · Wärme · Strom</span>
            </div>
          </a>
        )}
        */}

        {/* Tool-Switcher */}
        <div id="neko-tool-tabs" className="flex gap-2" role="tablist" aria-label="Tool auswählen">
          <button
            role="tab"
            aria-selected={activeTool === "foerder-rechner"}
            onClick={() => onToolChange("foerder-rechner")}
            className={clsx(
              "flex-1 flex items-center justify-center gap-2 py-2 px-3 rounded-lg text-sm font-medium transition-all",
              activeTool === "foerder-rechner"
                ? "bg-neko-orange text-neko-dark"
                : "bg-neko-dark-3 text-neko-gray hover:text-neko-white"
            )}
            data-testid="tab-foerder-rechner"
          >
            <Home className="w-4 h-4" />
            Förder-Rechner
          </button>
          <button
            role="tab"
            aria-selected={activeTool === "dach-mapper"}
            onClick={() => onToolChange("dach-mapper")}
            className={clsx(
              "flex-1 flex items-center justify-center gap-2 py-2 px-3 rounded-lg text-sm font-medium transition-all",
              activeTool === "dach-mapper"
                ? "bg-neko-orange text-neko-dark"
                : "bg-neko-dark-3 text-neko-gray hover:text-neko-white"
            )}
            data-testid="tab-dach-mapper"
          >
            <Map className="w-4 h-4" />
            Dach-Mapper
          </button>
          <button
            role="tab"
            aria-selected={activeTool === "roi-simulator"}
            onClick={() => onToolChange("roi-simulator")}
            className={clsx(
              "flex-1 flex items-center justify-center gap-2 py-2 px-3 rounded-lg text-sm font-medium transition-all",
              activeTool === "roi-simulator"
                ? "bg-neko-orange text-neko-dark"
                : "bg-neko-dark-3 text-neko-gray hover:text-neko-white"
            )}
            data-testid="tab-roi-simulator"
          >
            <Zap className="w-4 h-4" />
            Solar-Rechner
          </button>
        </div>
      </div>
    </header>
  );
}
